export default {
  'vehicle-list': ['vehicle_management'],
  'vehicle-repair': ['vehicle_repair_management']
}
